import api from "./api";

const StockInService = {
  save: (data) => api.post("/stockIn/save", data),
  // getAll: (companyId) => api.get(`/stockIn/getAll/${companyId}`),
  // getAll: (companyId, employeeId, roleId, page, limit) =>
  //   api.get(`/stockIn/getAll/${companyId}/${employeeId}/${roleId}`, {

  //     params: {
  //       page,
  //       limit

  //     }
  //   }),

  getAll: (
    companyId,
    employeeId,
    roleId,
    page,
    limit,
    search,
    status
  ) =>
    api.get(
      `/stockIn/getAll/${companyId}/${employeeId}/${roleId}`,
      {
        params: {
          page,
          limit,
          search,
          status
        }
      }
    ),
  getById: (id) => api.get(`/stockIn/getById/${id}`),
  update: (id, data) => api.put(`/stockIn/update/${id}`, data),
  updateStatus: (id, data) => api.put(`/stockIn/updatestatus/${id}`, data),
  // NEW APIs
  approve: (id, data) => api.put(`/stockIn/approve/${id}`, data),

  reject: (id, data) => api.put(`/stockIn/reject/${id}`, data),

  cancel: (id, data) => api.put(`/stockIn/cancel/${id}`, data),

  previewVoucherNo: (projectId, storeId) =>
    api.get(`/stockIn/preview-voucher/${projectId}/${storeId}`),
};

export default StockInService;
